import {Config} from "vuescroll";

export const ops: Config = {
  bar: {
    keepShow: true,
    background: "#ffffff3d",
  },
};
